module.exports = __webpack_public_path__ + "static/img/beta_bg_white_06.deec3adb.svg";